import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicSelect, BaasicConfirmModal, BaasicCheckbox, Loader, SliderCheckBox } from 'core/components';
import { channelType } from 'common/constants';

import _ from 'lodash';

const ChangeShippingTemplate = ({
	t,
	changeShippingViewStore: {
		loading,
		form,
		warehouseOptions,
		onWarehouseSelect,
		onCarrierServiceSelect,
		carrierServiceOptions,
		disableSaveBtn,
		openVoidActiveLabelConfirmModal,
		voidActiveLabelConfirmModal,
		onCheck,
		useBuyShipping,
		selectedItem,
		selectedItems,
		handleOnWarehouseMenuScroll,
		handleOnServiceCarrierMenuScroll,
		isCarrierServiceLoading,
		debouncedWarehouseSearch,
		debouncedCarrierServiceSearch,
		onMenuClose,
		isWarehouseDropdownLoading,
		isBulkAction,
		isAllAmazon,
		onIgnoreDeliverByDateChange,
		isSuperAdminOrganization,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('CHANGESHIPPINGVIEW.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicSelect
						field={form.$('assignedWarehouse')}
						clearable={false}
						options={warehouseOptions.slice()}
						onChange={onWarehouseSelect}
						value={form.$('assignedWarehouse').value}
						onMenuScrollToBottom={handleOnWarehouseMenuScroll}
						onInputChange={debouncedWarehouseSearch}
						isLoading={isWarehouseDropdownLoading}
						onBlur={onMenuClose}
						className="spc--bottom--sml flex--grow--1"
					/>
					<BaasicSelect
						field={form.$('assignedCarrierService')}
						isLoading={isCarrierServiceLoading}
						options={carrierServiceOptions.slice()}
						onChange={onCarrierServiceSelect}
						value={form.$('assignedCarrierService').value}
						onMenuScrollToBottom={handleOnServiceCarrierMenuScroll}
						onInputChange={debouncedCarrierServiceSearch}
						isClearable={true}
						className="spc--bottom--sml flex--grow--1"
						useCustomOption={true}
					/>

					{selectedItem != null &&
						selectedItems == null &&
						!isSuperAdminOrganization &&
						selectedItem.order.channel.channelType.name === channelType.amazon && (
							<div className="spc--bottom--sml">
								<BaasicCheckbox
									id={form.$('useBuyShipping').name}
									onChange={onCheck}
									label="CHANGESHIPPINGVIEW.USEBUYSHIPPING"
									checked={form.$('useBuyShipping').value}
								/>
							</div>
						)}

					{isBulkAction && isAllAmazon && !isSuperAdminOrganization && (
						<div className="spc--bottom--sml">
							<BaasicCheckbox
								id={form.$('useBuyShipping').name}
								onChange={onCheck}
								label={'CHANGESHIPPINGVIEW.USEBUYSHIPPING'}
								checked={useBuyShipping}
								disabled={!isAllAmazon}
							/>
						</div>
					)}
					{isBulkAction && !isAllAmazon && !isSuperAdminOrganization && (
						<div className="spc--bottom--sml">{t('BUYSHIPPINGOPTIONDISABLED')}</div>
					)}

					{isSuperAdminOrganization && (
						<div className="flex--primary spc--bottom--sml">
							<div className="spc--right--xsml">
								<SliderCheckBox field={form.$('ignoreDeliverByDate')} onValueChange={onIgnoreDeliverByDateChange} />
							</div>
							<div>
								<label className="type--wgt--bold type--color--text">
									{t('CHANGESHIPPINGVIEW.IGNOREDELIVERBYDATE')}
								</label>
								{((selectedItem != null && selectedItem.order.channel.channelType.name === channelType.amazon) ||
									(selectedItems != null &&
										selectedItems.some(item => item.order.channel.channelType.name === channelType.amazon))) && (
									<span className="display--b type--color--grey-5">
										{t('CHANGESHIPPINGVIEW.IGNOREDELIVERBYDATEFORAMAZON')}
									</span>
								)}
							</div>
						</div>
					)}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="button"
						onClick={openVoidActiveLabelConfirmModal}
						disabled={form.$('assignedCarrierService').value === null || disableSaveBtn}
					>
						{t('SAVE')}
					</button>
				</div>
			</form>
			<BaasicConfirmModal modalParams={voidActiveLabelConfirmModal} />
		</section>
	);
};

export default defaultTemplate(ChangeShippingTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ChangeShippingTemplate.jsx